<template>
    <div>
        <blog></blog>
    </div>
</template>

<script>
import Blog from "../../Blog/Blog";
export default {
    name: "MyBlog",
    components: {Blog},
};
</script>

<style></style>
